import { CONFIG } from "../config.ts";
import { clamp, randRange, TAU } from "../math.ts";

// The roaming Buddha. Wanders serenely and periodically drops golden poop.
export class Buddha {
  x: number;
  y: number;
  radius = 46;
  animT = 0;
  faceX = 1;
  faceY = 0;
  private vx: number;
  private vy: number;
  private aimTimer = 0;
  private goldenTimer: number;

  constructor(x: number, y: number, rng: () => number) {
    this.x = x;
    this.y = y;
    const a = rng() * TAU;
    this.vx = Math.cos(a) * CONFIG.buddha.speed;
    this.vy = Math.sin(a) * CONFIG.buddha.speed;
    this.goldenTimer = randRange(rng, CONFIG.buddha.goldenIntervalMin, CONFIG.buddha.goldenIntervalMax);
  }

  /** Returns true when it drops a golden poop this frame. */
  update(dt: number, rng: () => number): boolean {
    this.animT += dt;

    this.aimTimer -= dt;
    if (this.aimTimer <= 0) {
      this.aimTimer = randRange(rng, 3, 6);
      const a = rng() * TAU;
      this.vx = Math.cos(a) * CONFIG.buddha.speed;
      this.vy = Math.sin(a) * CONFIG.buddha.speed;
    }

    this.x += this.vx * dt;
    this.y += this.vy * dt;

    const r = this.radius;
    if (this.x < r || this.x > CONFIG.world.width - r) this.vx *= -1;
    if (this.y < r || this.y > CONFIG.world.height - r) this.vy *= -1;
    this.x = clamp(this.x, r, CONFIG.world.width - r);
    this.y = clamp(this.y, r, CONFIG.world.height - r);

    const sp = Math.hypot(this.vx, this.vy) || 1;
    this.faceX = this.vx / sp;
    this.faceY = this.vy / sp;

    this.goldenTimer -= dt;
    if (this.goldenTimer <= 0) {
      this.goldenTimer = randRange(rng, CONFIG.buddha.goldenIntervalMin, CONFIG.buddha.goldenIntervalMax);
      return true;
    }
    return false;
  }
}
